import { useMemo } from 'react';
import utils from '@/common/utils';
import TfLaunch from '@/micro-app/tf-launch';

function Launch() {
  const planCode = useMemo(() => {
    return utils.getQuery('planCode')!;
  }, []);

  return <TfLaunch data={{ planCode }} />;
}

export default Launch;
